<template>
  <div class="login-container">
    <a-card class="login-card" :bordered="false">
      <a href="https://quickguide-2fa-published-2mq4zmn.gamma.site/" target="_blank" rel="noopener noreferrer"
        class="info-icon">
        <a-icon type="info-circle" /> <span>Read Manual</span>
      </a>
      <div class="login-header">
        <img src="/images/MUIC_Logo_Eng_Center.png" alt="MUIC Logo" class="login-logo" />
        <h2 class="login-title">IC Portal Login</h2>
        <p class="login-subtitle">Please select a login method</p>
      </div>
      <div class="login-actions">
        <a-button type="primary" size="large" block class="login-btn keycloak-btn" :loading="isLoading"
          @click="loginWithMicrosoft">
          MUIC SSO (Preferred)
          <br><small style="font-weight: 400; opacity: 0.85; font-size: 12px;">Login with your SKY+/MUIC Account
            @muic.io</small>
        </a-button>
        <!--  
          <div class="old-sso-container">
          <a class="old-sso-link" @click="loginWithKeycloak">
            Old MUIC SSO
          </a>
        </div>
        -->
      </div>
    </a-card>
  </div>
</template>

<script>
import authService from '../services/authService';
import moment from 'moment';

export default {
  name: 'Login',
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    remainingDays() {
      // Set expiration date to 3 months from now
      const expirationDate = moment().add(3, 'months');
      const today = moment();
      const diffDays = expirationDate.diff(today, 'days');
      return Math.max(diffDays, 0);
    }
  },
  methods: {
    loginWithKeycloak() {
      // Use the Keycloak instance from main.js
      if (this.$keycloak) {
        this.$keycloak.login({
          redirectUri: globalThis.location.origin + '/dashboard'
        });
      } else {
        console.error('Keycloak instance not found');
        this.$message.error('Keycloak login is not available.');
      }
    },
    async loginWithMicrosoft() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const response = await authService.login();
        if (response) {
          this.$message.success('Login Successful');
          this.$router.push('/dashboard');
        } else {
          // response null means interaction_in_progress was handled or ignored
          // We can stop loading, but maybe no message is needed as authService logged a warning
          // Or we can check if it was a user cancellation
        }
      } catch (error) {
        console.error(error);
        this.$message.error('Microsoft Login Failed');
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  background-image: url('/images/bg_sso_ic.jpg');
  background-size: cover;
  background-position: center;
}

.login-card {
  position: relative;
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 0.95);
}

.info-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 11px;
  color: #8c8c8c;
  transition: color 0.3s;
  text-decoration: none;

  &:hover {
    color: #502B80;
  }
}

.login-header {
  text-align: center;
  margin-bottom: 24px;
}

.login-logo {
  max-width: 216px;
  height: auto;
  margin-bottom: 16px;
}

.login-title {
  font-size: 24px;
  font-weight: 600;
  color: #502B80;
  /* Updated Color */
  margin-bottom: 8px;
}

.login-subtitle {
  color: #502B80;
  /* Updated Color */
  font-size: 14px;
  margin-top: -10px;
}

.login-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-btn {
  min-height: 48px;
  height: auto;
  padding: 8px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;

  &.keycloak-btn {
    background-color: #502B80;
    border-color: #502B80;

    &:hover {
      background-color: #693382;
      /* Lighter shade for hover */
      border-color: #693382;
    }
  }
}

.old-sso-container {
  text-align: right;
}

.old-sso-link {
  font-size: 12px;
  color: #8c8c8c;
  text-decoration: underline;
  font-style: italic;
  transition: color 0.3s;

  &:hover {
    color: #502B80;
  }
}

.expired-warning {
  color: #ff4d4f;
  /* Ant Design Red */
  font-weight: 600;
}
</style>
